import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'dateAgo'
})
export class DateAgoPipe implements PipeTransform {

    transform(value: any, args?: any): any {
        if (value) {
            const currentDate = new Date();
            const inputDate = new Date(value);

            if (inputDate > currentDate) {
                const millisecondsDiff = inputDate.getTime() - currentDate.getTime();
                const secondsDiff = Math.floor(millisecondsDiff / 1000);
                const minutesDiff = Math.floor(secondsDiff / 60);
                const hoursDiff = Math.floor(minutesDiff / 60);
                const daysDiff = Math.floor(hoursDiff / 24);

                // Check the difference and return formatted output
                if (daysDiff === 1) {
                    return 'After 1 day';
                } else if (daysDiff === 0) {
                    return 'Today'
                } else {
                    return `After ${daysDiff} days`;
                }
            }

            const seconds = Math.floor((currentDate.getTime() - inputDate.getTime()) / 1000);
            if (seconds < 29) {
                return 'Just now';
            }

            const intervals = {
                'year': 31536000,
                'month': 2592000,
                'week': 604800,
                'day': 86400,
                'hr': 3600,
                'min': 60,
                'sec': 1
            };

            let counter;
            for (const i in intervals) {
                counter = Math.floor(seconds / intervals[i]);
                if (counter > 0) {
                    if (counter === 1) {
                        return counter + ' ' + i + ' ago'; // singular (1 day ago)
                    } else {
                        return counter + ' ' + i + 's ago'; // plural (2 days ago)
                    }
                }
            }
        }
        return value;
    }
}
